(ns app.domain.application.guards.appeals
  (:require [app.domain.appeals.model :as appeals-model]
            [app.domain.util :as du]
            [core.db.entity.util :as eu]))

(def tribunals-defined?
  {:name    :process.guard/tribunals-defined?
   :type    :guard
   :handler (fn [{{:keys [target]} :request}]
              (->> target
                   :entity/parent ; workspace
                   :domain/authority-group
                   (du/find-descendant (eu/is-type-fn :entity.type/appeals-tribunal))))})


(def appeal-dates-set?
  {:name    :process.guard/appeal-dates-set?
   :type    :guard
   :handler (fn [{{:keys [target]} :request}]
              (->> target
                   appeals-model/application-appeals
                   (filter (du/in-state-fn :appeals-information.state/in-progress))
                   (every? (every-pred
                             :appeals-information/date-of-decision
                             :appeals-information/date-of-meeting
                             :appeals-information/date-of-appeal))))})


(def guards
  [tribunals-defined?
   appeal-dates-set?])
